'use client';
import { useThemeSetting } from '../../provider/index.js';
import { useBlock } from './useBlock.js';
import { safeArraySpread } from '../utils.js';
/**
 * Returns the block style (if available)
 *
 * @param node DomNode
 * @returns
 */
export function useBlockTypography(node) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { name, attributes } = useBlock(node);
    const defaultFontSizesSettings = useThemeSetting('typography.fontSizes.default', null, []);
    const themeFontSizesSettings = useThemeSetting('typography.fontSizes.theme', null, []);
    const userFontSizesSettings = useThemeSetting('typography.fontSizes.user', null, []);
    const blockFontSizesSettings = useThemeSetting('typography.fontSizes.theme', name, [], false);
    const supportsCustomFontSize = !!useThemeSetting('typography.customFontSize', name);
    const supportsFontStyle = !!useThemeSetting('typography.fontStyle', name);
    const supportsFontWeight = !!useThemeSetting('typography.fontWeight', name);
    const supportsLetterSpacing = !!useThemeSetting('typography.letterSpacing', name);
    const supportsLineHeight = !!useThemeSetting('typography.lineHeight', name);
    const supportsTextDecoration = !!useThemeSetting('typography.textDecoration', name);
    const supportsTextTransform = !!useThemeSetting('typography.textTransform', name);
    const allFontSizes = [
        ...safeArraySpread(blockFontSizesSettings),
        ...safeArraySpread(userFontSizesSettings),
        ...safeArraySpread(themeFontSizesSettings),
        ...safeArraySpread(defaultFontSizesSettings),
    ];
    const fontSizePreset = attributes === null || attributes === void 0 ? void 0 : attributes.fontSize;
    if (fontSizePreset) {
        return {
            fontSize: {
                slug: fontSizePreset || '',
                value: ((_a = allFontSizes.find((f) => f.slug === fontSizePreset)) === null || _a === void 0 ? void 0 : _a.size) ||
                    ((_b = attributes === null || attributes === void 0 ? void 0 : attributes.style) === null || _b === void 0 ? void 0 : _b.typography),
            },
            supportsFontStyle,
            supportsCustomFontSize,
            supportsFontWeight,
            supportsLetterSpacing,
            supportsLineHeight,
            supportsTextDecoration,
            supportsTextTransform,
            lineHeight: (_d = (_c = attributes === null || attributes === void 0 ? void 0 : attributes.styleConfig) === null || _c === void 0 ? void 0 : _c.typography) === null || _d === void 0 ? void 0 : _d.lineHeight,
            textTransform: (_f = (_e = attributes === null || attributes === void 0 ? void 0 : attributes.styleConfig) === null || _e === void 0 ? void 0 : _e.typography) === null || _f === void 0 ? void 0 : _f.textTransform,
            letterSpacing: (_h = (_g = attributes === null || attributes === void 0 ? void 0 : attributes.styleConfig) === null || _g === void 0 ? void 0 : _g.typography) === null || _h === void 0 ? void 0 : _h.letterSpacing,
        };
    }
    return {
        fontSize: {
            slug: '',
            value: '',
        },
        supportsFontStyle,
        supportsCustomFontSize,
        supportsFontWeight,
        supportsLetterSpacing,
        supportsLineHeight,
        supportsTextDecoration,
        supportsTextTransform,
        lineHeight: '',
        textTransform: '',
        letterSpacing: '',
    };
}
